import { Checkbox } from "antd";
import { fmtTimeHM } from "../../extensions/utils";
import { isMobile } from "@/extensions/design";

const VisitItem = ({ item, onClick }) => {
  const getImage = () => {
    if (item.recordId) return <img src="/images/calendar.svg" alt="record"/>
    if (item.imageId) return <img src={`${process.env.REACT_APP_API_BASE_URL}/api/image/${item.imageId}.jpg`} alt="client" className={isMobile ? "client-photo" : ""}/>
    return <img src={item.clientId ? "/images/card.svg" : "/images/mask.svg"} alt="client"/>
  }

  return<div className="client-item" onClick={onClick}>
    <div className="client-item-photo">{getImage()}</div>
    <div className="visit-item-body">
      <div className="visit-item-line1">
        <div style={{fontWeight: 600}}>{item.clientName}</div>
        <div className="vitis-item-clip" style={{textAlign: "center"}}><Checkbox checked={item.finish} /></div>
        <div style={{textAlign: "center", fontWeight: 600}}>{fmtTimeHM(item.start)}</div>
      </div>
      <div className="visit-item-line2">
        <div># {item.id}</div>
        <div className="vitis-item-clip">{item.productName}</div>
        <div style={{textAlign: "center"}}>{item.keyName}</div>
      </div>
    </div>
  </div>
}

export default VisitItem;